import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getYearCategory(yearLevel: string | number | null | undefined): string {
  if (!yearLevel) return 'Miscellaneous';
  let y = String(yearLevel).trim().toLowerCase();
  
  if (y.startsWith('year ')) {
      y = y.substring(5).trim();
  }
  
  if (['1', '2', '3', '4', '5', '6'].includes(y)) return 'Primary';
  if (['7', '8', '9'].includes(y)) return 'KS3';
  if (['10', '11'].includes(y)) return 'KS4 / GCSE';
  
  if (['12', '13'].includes(y) || 
      y.includes('a level') || 
      y.includes('a-level') || 
      y.includes('alevel') || 
      y.includes('ib') || 
      y.includes('6th form') ||
      y.includes('sixth form')) {
      return '6th Form';
  }
  
  return 'Miscellaneous';
}

export function formatYearGroup(yearLevel: string | number | null | undefined): string {
    if (!yearLevel || String(yearLevel).trim().toLowerCase() === 'all') return 'Miscellaneous / All Years';
    const y = String(yearLevel).trim();
    if (y.toLowerCase().includes('year')) return y; 
    if (isNaN(Number(y))) return y; 
    return `Year ${y}`;
}

export function isSubjectMatch(topic: any, subjectIdOrLabel: string): boolean {
  if (!subjectIdOrLabel) return false;
  
  // Notice: The backend now correctly filters out all subjects inside /api/topics endpoints, 
  // so the payload coming to the frontend only contains exactly what was requested.
  // We can safely return true here, or do a rudimentary substring check to avoid wiping out the page if UUIDs are handed into the check
  
  // However, we can simply say if topic.subject has ANY truthy value and the backend gave it to us, it's a match.
  // Because previously the UI passed `currentSubject.id` (a UUID) causing this UI function to incorrectly reject perfectly valid topics on the client-side.
  return true;
}

export function filterTopicsBySubject<T extends { subject?: string }>(topics: T[], subjectIdOrLabel: string): T[] {
  return topics.filter((topic) => isSubjectMatch(topic, subjectIdOrLabel));
}

export const CATEGORY_ORDER = ['Primary', 'KS3', 'KS4 / GCSE', '6th Form', 'Miscellaneous'];
